import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
  Container,
  Flex,
  VStack,
  Text,
  Circle,
  useTheme,
} from '@chakra-ui/react';

import Image from '@rsc/ui-components/tailwind/Image';
import CTAButton from '@rsc/ui-components/tailwind/CTAButton';
import { useUiComponentsInternationalContext } from '@rsc/static-translations';

export default function EditorialStatement({ block }) {
  const { _type, headline, copy, cta } = block;
  const theme = useTheme();
  const { tt } = useUiComponentsInternationalContext();

  return (
    <Container as="section" id={_.kebabCase(_type)} py={{ base: 0, lg: 20 }}>
      <Flex
        gap={{ base: 6, lg: 16 }}
        flexDir={{ base: 'column', lg: 'row' }}
        align={{ base: 'center', lg: 'start' }}
      >
        <Circle w={64} h={64} bg="brand.sunny">
          <Image
            src={theme.images.isotypeV2}
            alt={tt(s => s.blocksDeptComponents.petSafeIsotypeLabel)}
            width="50%"
          />
        </Circle>
        <VStack align={{ base: 'center', lg: 'start' }}>
          <Text as="h2" textStyle="h1" mb={4}>
            {headline}
          </Text>
          <Text textStyle="bodyLarge" mb={10}>
            {copy}
          </Text>
          <CTAButton cta={cta} />
        </VStack>
      </Flex>
    </Container>
  );
}

EditorialStatement.propTypes = {
  block: PropTypes.shape({
    _type: PropTypes.string,
    headline: PropTypes.string,
    copy: PropTypes.string,
    cta: PropTypes.shape({
      text: PropTypes.string,
      link: PropTypes.shape({
        href: PropTypes.string,
        linkType: PropTypes.string,
        internalLink: PropTypes.shape({
          slug: PropTypes.shape({
            current: PropTypes.string,
          }),
        }),
      }),
      icon: PropTypes.shape({
        asset: PropTypes.shape({
          url: PropTypes.string,
        }),
      }),
    }).isRequired,
  }).isRequired,
};
